import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IField, IInputFieldOptions, IValueChangedEventArgs } from '@azavista/components/shared';
import { SharedService, TranslationKey } from '../../shared';
import { IEntityUpdatedTriggerDialogComponentData, TriggerNames } from './interfaces';

@Component({
    templateUrl: 'entity-updated-trigger.component.html'
})
export class EntityUpdatedTriggerDialogComponent implements OnInit {
    field: IField;
    fieldValue: TriggerNames;
    fieldOptions: IInputFieldOptions;
    isLoaded = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IEntityUpdatedTriggerDialogComponentData,
        private dialogRef: MatDialogRef<EntityUpdatedTriggerDialogComponent, IEntityUpdatedTriggerDialogComponentData>,
        private sharedSvc: SharedService
    ) {
    }

    ngOnInit(): void {
        this.field = this.createField();
        this.fieldValue = this.data.selectedTriggers;
        this.isLoaded = true;
    }

    onFieldValueChanged(args: IValueChangedEventArgs): void {
        this.data.selectedTriggers = (args.value as TriggerNames);
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onCreate(): void {
        this.dialogRef.close(this.data);
    }

    createField(): IField {
        // const enumItems: EventEntityUpdatedTriggerTriggerName[] = [
        //     EventEntityUpdatedTriggerTriggerName.addTeams,
        //     EventEntityUpdatedTriggerTriggerName.create,
        //     EventEntityUpdatedTriggerTriggerName.removeTeams,
        //     EventEntityUpdatedTriggerTriggerName.replaceTeams,
        //     EventEntityUpdatedTriggerTriggerName.settings,
        //     EventEntityUpdatedTriggerTriggerName.update,
        // ];
        // this.fieldOptions = {
        //     translations: {
        //         [this.data.language]: {
        //             [EventEntityUpdatedTriggerTriggerName.addTeams]: this.sharedSvc.translate(TranslationKey.addTeams),
        //             [EventEntityUpdatedTriggerTriggerName.create]: this.sharedSvc.translate(TranslationKey.create),
        //             [EventEntityUpdatedTriggerTriggerName.removeTeams]: this.sharedSvc.translate(TranslationKey.removeTeams),
        //             [EventEntityUpdatedTriggerTriggerName.replaceTeams]: this.sharedSvc.translate(TranslationKey.replaceTeams),
        //             [EventEntityUpdatedTriggerTriggerName.settings]: this.sharedSvc.translate(TranslationKey.settings),
        //             [EventEntityUpdatedTriggerTriggerName.update]: this.sharedSvc.translate(TranslationKey.update)
        //         }
        //     }
        // };
        this.fieldOptions = { translations: this.data.translations };
        const field: IField = {
            id: 'trigger', name: 'trigger', editable: true,
            label: this.sharedSvc.translate(TranslationKey.trigger),
            schema: { type: 'array', items: { type: 'string', enum: this.data.allTriggers } }
        } as IField;
        return field;
    }
}
